/* Venelora: bundles, cart drawer, carousels, countdown, sticky ATC, before/after */
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var SECTIONS = 'vn-cart-drawer,cart-icon-bubble';

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---------- Countdown to midnight (evergreen "ultimo giorno") ---------- */
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function tickCountdowns() {
    var now = new Date();
    var end = new Date(now); end.setHours(23, 59, 59, 999);
    var s = Math.max(0, Math.floor((end - now) / 1000));
    var h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
    $$('[data-vn-countdown]').forEach(function (el) {
      var hh = $('[data-h]', el), mm = $('[data-m]', el), ss = $('[data-s]', el);
      if (hh) hh.textContent = pad(h);
      if (mm) mm.textContent = pad(m);
      if (ss) ss.textContent = pad(sec);
    });
  }

  /* ---------- Shipping date ("Spedizione da domani giovedì 5 novembre") ---------- */
  function shipDates() {
    var d = new Date(); d.setDate(d.getDate() + 1);
    var txt;
    try { txt = d.toLocaleDateString('it-IT', { weekday: 'long', day: 'numeric', month: 'long' }); }
    catch (e) { txt = d.getDate() + '/' + (d.getMonth() + 1); }
    $$('[data-vn-shipdate]').forEach(function (el) { el.textContent = txt; });
  }

  /* ---------- Gallery ---------- */
  function initGallery(g) {
    var track = $('.vn-gallery__track', g);
    var thumbs = $$('.vn-gallery__thumb', g);
    if (!track) return;
    function go(i) { track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
    var prev = $('.vn-gallery__arrow--prev', g), next = $('.vn-gallery__arrow--next', g);
    function idx() { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); }
    if (prev) prev.addEventListener('click', function () { go(Math.max(0, idx() - 1)); });
    if (next) next.addEventListener('click', function () { go(Math.min(thumbs.length - 1, idx() + 1)); });
    track.addEventListener('scroll', function () {
      var i = idx();
      thumbs.forEach(function (t, j) { t.classList.toggle('is-active', i === j); });
      var a = thumbs[i];
      if (a && a.parentNode) a.parentNode.scrollTo({ left: a.offsetLeft - 40, behavior: 'smooth' });
    }, { passive: true });
  }

  /* ---------- Carousels with arrows and dots ---------- */
  function initCarousel(c) {
    var track = $('[data-vn-track]', c);
    if (!track) return;
    var items = Array.prototype.slice.call(track.children);
    var dotsWrap = $('[data-vn-dots]', c);
    if (dotsWrap && !dotsWrap.children.length) {
      items.forEach(function () { dotsWrap.appendChild(document.createElement('span')); });
    }
    var dots = dotsWrap ? Array.prototype.slice.call(dotsWrap.children) : [];
    function step() { return items[0] ? items[0].getBoundingClientRect().width + 14 : track.clientWidth; }
    function current() {
      var center = track.scrollLeft + track.clientWidth / 2, best = 0, bestD = Infinity;
      items.forEach(function (it, i) {
        var d = Math.abs(it.offsetLeft + it.offsetWidth / 2 - center);
        if (d < bestD) { bestD = d; best = i; }
      });
      return best;
    }
    function paint() { var i = current(); dots.forEach(function (d, j) { d.classList.toggle('is-active', i === j); }); }
    var prev = $('[data-vn-prev]', c), next = $('[data-vn-next]', c);
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { items[i].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' }); }); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(paint); }, { passive: true });
    if (c.hasAttribute('data-vn-start-middle') && items.length > 2) {
      setTimeout(function () { track.scrollLeft = items[1].offsetLeft - (track.clientWidth - items[1].offsetWidth) / 2; paint(); }, 50);
    }
    paint();
  }

  /* ---------- Before / after ---------- */
  function initBA(el) {
    var input = $('input[type=range]', el);
    if (!input) return;
    function set() { el.style.setProperty('--pos', input.value + '%'); }
    input.addEventListener('input', set); set();
  }

  /* ---------- Cart drawer ---------- */
  var drawer;
  function openDrawer() {
    drawer = drawer || $('#vn-cart-drawer');
    if (!drawer) { window.location.href = root + 'cart'; return; }
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('vn-lock');
    var close = $('.vn-drawer__close', drawer); if (close) close.focus({ preventScroll: true });
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('vn-lock');
  }
  function renderSections(sections) {
    if (!sections) return;
    if (sections['vn-cart-drawer']) {
      var doc = new DOMParser().parseFromString(sections['vn-cart-drawer'], 'text/html');
      var fresh = doc.querySelector('[data-vn-drawer-inner]');
      var cur = $('[data-vn-drawer-inner]');
      if (fresh && cur) cur.innerHTML = fresh.innerHTML;
    }
    if (sections['cart-icon-bubble']) {
      var d2 = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
      var src = d2.querySelector('.shopify-section');
      var bubble = document.getElementById('cart-icon-bubble');
      if (src && bubble) bubble.innerHTML = src.innerHTML;
    }
  }
  function refreshDrawer() {
    return fetch(root + '?sections=' + SECTIONS)
      .then(function (r) { return r.json(); })
      .then(renderSections);
  }
  function post(url, body) {
    return fetch(root + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw j; return j; });
    });
  }
  function getCart() { return fetch(root + 'cart.js').then(function (r) { return r.json(); }); }

  // Gifts only live in the cart next to a paid item: drop them when the last paid line goes.
  function cleanGifts(cart) {
    var paid = cart.items.filter(function (i) { return !(i.properties && i.properties._vn_gift); });
    if (paid.length) return Promise.resolve(null);
    var updates = {};
    cart.items.forEach(function (i) { updates[i.key] = 0; });
    if (!Object.keys(updates).length) return Promise.resolve(null);
    return post('cart/update.js', { updates: updates, sections: SECTIONS });
  }

  function changeLine(key, qty) {
    var body = $('[data-vn-drawer-body]');
    if (body) body.classList.add('is-loading');
    return post('cart/change.js', { id: key, quantity: qty, sections: SECTIONS })
      .then(function (cart) { renderSections(cart.sections); return cleanGifts(cart); })
      .then(function (res) { if (res && res.sections) renderSections(res.sections); })
      .catch(function () { return refreshDrawer(); })
      .then(function () { var b = $('[data-vn-drawer-body]'); if (b) b.classList.remove('is-loading'); });
  }

  function addItems(items, btn) {
    if (btn) btn.classList.add('is-loading');
    return post('cart/add.js', { items: items, sections: SECTIONS, sections_url: window.location.pathname })
      .then(function (res) { renderSections(res.sections); openDrawer(); })
      .catch(function (err) {
        var msg = (err && (err.description || err.message)) || 'Errore, riprova.';
        window.alert(msg);
      })
      .then(function () { if (btn) btn.classList.remove('is-loading'); });
  }

  /* ---------- Bundle form ---------- */
  function initBundleForm(form) {
    var bars = $$('.vn-bundle', form);
    var gifts = $$('[data-vn-gift]', form);
    function selectedIndex() {
      var idx = 0;
      bars.forEach(function (b, i) { var inp = $('input', b); if (inp && inp.checked) idx = i; });
      return idx;
    }
    function paint() {
      var idx = selectedIndex();
      bars.forEach(function (b, i) { b.classList.toggle('is-selected', i === idx); });
      gifts.forEach(function (g) {
        var from = parseInt(g.getAttribute('data-unlock') || '1', 10) - 1;
        g.classList.toggle('is-locked', idx < from);
      });
      // Subscription: the hidden selling_plan input and the renewal line follow the chosen bar
      var bar = bars[idx];
      var plan = bar ? bar.getAttribute('data-plan') || '' : '';
      var planInput = $('[data-vn-plan-input]', form);
      if (planInput) { planInput.value = plan; planInput.disabled = !plan; }
      if (bar) {
        $$('[data-vn-plan-name]', form).forEach(function (el) { el.textContent = (bar.getAttribute('data-plan-name') || '').toLowerCase(); });
        $$('[data-vn-plan-price]', form).forEach(function (el) { el.textContent = bar.getAttribute('data-plan-price') || ''; });
      }
    }
    bars.forEach(function (b) { var inp = $('input', b); if (inp) inp.addEventListener('change', paint); });
    paint();

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = $('[type=submit]', form);
      var idx = selectedIndex();
      var bar = bars[idx];
      var input = bar ? $('input', bar) : $('input[name=id]', form);
      if (!input) return;
      var bundleName = bar ? (bar.getAttribute('data-name') || '') : '';
      var items = [{ id: parseInt(input.value, 10), quantity: parseInt(bar && bar.getAttribute('data-qty') || '1', 10) }];
      var plan = bar ? bar.getAttribute('data-plan') : '';
      if (plan) items[0].selling_plan = parseInt(plan, 10);
      getCart().then(function (cart) {
        var inCart = {};
        cart.items.forEach(function (i) { inCart[i.variant_id] = true; });
        gifts.forEach(function (g) {
          var vid = parseInt(g.getAttribute('data-variant') || '0', 10);
          if (!vid || g.classList.contains('is-locked') || inCart[vid]) return;
          items.push({ id: vid, quantity: 1, properties: { _vn_gift: '1', _vn_bundle: bundleName } });
        });
        return addItems(items, btn);
      }).catch(function () { return addItems(items, btn); });
    });
  }

  /* ---------- Sticky ATC ---------- */
  function initSticky(st) {
    var target = $(st.getAttribute('data-target') || '[data-vn-atc]');
    var btn = $('button', st);
    if (btn) btn.addEventListener('click', function () {
      var form = $('[data-vn-bundle-form]');
      if (form) {
        if (form.requestSubmit) form.requestSubmit(); else $('[type=submit]', form).click();
      } else {
        var href = st.getAttribute('data-href'); if (href) window.location.href = href;
      }
    });
    if (!target || !('IntersectionObserver' in window)) { st.classList.add('is-visible'); return; }
    var seen = false;
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { seen = true; st.classList.remove('is-visible'); }
        else if (seen || en.boundingClientRect.top < 0) { st.classList.add('is-visible'); }
      });
    }, { threshold: 0 }).observe(target);
  }

  /* ---------- Wire up ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var cartIcon = t.closest && t.closest('#cart-icon-bubble, [data-vn-open-cart]');
    if (cartIcon && $('#vn-cart-drawer')) { e.preventDefault(); openDrawer(); return; }
    if (t.closest && t.closest('[data-vn-close-cart]')) { e.preventDefault(); closeDrawer(); return; }
    var q = t.closest && t.closest('[data-vn-qty]');
    if (q) {
      e.preventDefault();
      changeLine(q.getAttribute('data-key'), parseInt(q.getAttribute('data-vn-qty'), 10));
      return;
    }
    var up = t.closest && t.closest('[data-vn-upsell]');
    if (up) {
      e.preventDefault();
      addItems([{ id: parseInt(up.getAttribute('data-vn-upsell'), 10), quantity: 1 }], up);
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  function init() {
    tickCountdowns(); setInterval(tickCountdowns, 1000);
    shipDates();
    $$('[data-vn-gallery]').forEach(initGallery);
    $$('[data-vn-carousel]').forEach(initCarousel);
    $$('[data-vn-ba]').forEach(initBA);
    $$('[data-vn-bundle-form]').forEach(initBundleForm);
    $$('[data-vn-sticky]').forEach(initSticky);
    drawer = $('#vn-cart-drawer');
    if (window.location.hash === '#cart' || /[?&]vn_cart=1/.test(window.location.search)) openDrawer();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  window.VN = { openCart: openDrawer, closeCart: closeDrawer, refreshCart: refreshDrawer };
})();
